import React, { PureComponent } from "react";
import { connect } from "react-redux";
import TitleBar from "../../_common/TitleBar";
import adrListTitleBarMenu from "../../_titleBarMenus/adrListTitleBarMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProjDashWidget from "./projDashWidget";
import { loadProjDashWidgets, updateProjDashWidget } from "../../../_actions/dashActions";
import { actionScripts } from "../../../_helpers/actionScripts";
import PilotBadge from "../../_common/PilotBadge";
import ProjectStatusBubble from "../../_common/ProjectStatusBubble";
// import { isNullOrEmpty } from "../../../_utils/generalUtils";

export class ProjDash extends PureComponent {
  state = {
    widgetOrder: {}, // Keys: order (int), Values: widgetType (string)
    leftWidgetPos: 0,
  };

  componentDidMount() {
    const { projectId, dispatch } = this.props;
    /**
     * 1. Preselected (or user-selected) proj dash widgets are stored
     *    under UserDto's ProjectDashboard, in the form of a comma-
     *    separated string.
     * 2. If no dashboards are found, provide default set of widgets.
     * 3. loadProjDashWidgets action creator takes the string from #1
     *    and builds a normalized object of widgets, in redux store.
     * 4. Loop through each key of the object from #2 and invoke
     *    updateWidgetData (which then invokes the widget's dataProvider
     *    and stores the result in the same widget's 'data' field.).
     */

    // #1
    // let projDashWidgets = "";
    // let projDashResult = authentication.user.projectDashboard.find(
    //   d => d.projectId === projectId
    // );

    // #2
    // if (!projDashResult || isNullOrEmpty(projDashResult.widgets))
    let projDashWidgets = "SAFETY_COMMENTS_RAISED,STAFF_ASSIGNMENTS,ADR_STATUS";
    // else projDashWidgets = projDashResult.widgets;

    // #3
    dispatch(loadProjDashWidgets(projectId, projDashWidgets)).then(() => {
      const { projDashWidgets } = this.props; // Get widgets from updated props
      let widgetOrder = {};
      let widgetIndex = 0;
      // #4
      for (var widget in projDashWidgets) {
        dispatch(updateProjDashWidget(widget, projectId));
        // this.updateWidgetData(projDashWidgets[widget].widgetType);
        widgetOrder[widgetIndex] = widget;
        widgetIndex++;
      }
      this.setState({ widgetOrder });
    });
  }

  handleTitleBarAction = (e) => {};

  handleClick_quickLink = (e) => {
    e.preventDefault();
    const { project, projectId } = this.props;
    
    switch (e.target.name) {
      case "projAdmin":
        actionScripts.OPEN_PROJ_ADMIN.run(projectId);
        break;
      case "projAssignments":
        actionScripts.OPEN_PROJ_ASSIGNMENT.run(projectId);
        break;
      case "payEstimates":
        actionScripts.OPEN_PAY_ESTIMATES.run(projectId);
        break;
      case "adrList":
        actionScripts.OPEN_ADR_LIST.run(projectId);
        break;
      case "reDashboard":
        if (project.fullEA) {
          actionScripts.OPEN_RE_DASHBOARD.run(projectId, project.fullEA);
        } else {
          console.warn("Project EA value not available");
        }
        break;
      case "projDocumentation":
          if (project.fullEA) {
          actionScripts.OPEN_PROJECT_DOCS.run(projectId, project.fullEA);

          } else {
          console.warn("Project EA value not available");
          }
      default:
        break;
    }
  };

  renderWidgets = () => {
    const { projectId } = this.props;
    const widgets = { ...this.props.projDashWidgets };
    const { widgetOrder, leftWidgetPos } = this.state;
    const widgetCount = Object.keys(widgetOrder).length;
    let midWidgetPos = leftWidgetPos + 1;
    let rightWidgetPos = leftWidgetPos + 2;
    if (midWidgetPos > widgetCount - 1) midWidgetPos -= widgetCount;
    if (rightWidgetPos > widgetCount - 1) rightWidgetPos -= widgetCount;
    const visibleWidgets = [
      widgetOrder[leftWidgetPos],
      widgetOrder[midWidgetPos],
      widgetOrder[rightWidgetPos],
    ];
    // console.log("visibleWidgets=", visibleWidgets);
    let widgetsForRender = [];
    visibleWidgets.forEach((w) => {
      widgets[w] !== undefined && widgetsForRender.push(widgets[w]);
    });
    return widgetsForRender.map((w, index) => {
      const colClassName =
        index === 0 ? "pr-1" : index === 1 ? "px-1" : index === 2 && "pl-1";
      return (
        <div className={"col-4 " + colClassName} key={`projDashWidget_${index}`}>
          <ProjDashWidget widget={w} index={index} projectId={projectId} />
        </div>
      );
    });
  };

  handleClick_scrollLeft = (e) => {
    e.preventDefault();
    const { widgetOrder } = this.state;
    let leftWidgetPos = this.state.leftWidgetPos;
    if (leftWidgetPos === 0) {
      const order = Object.keys(widgetOrder);
      leftWidgetPos = order.length - 1;
    } else leftWidgetPos--;
    this.setState({ leftWidgetPos });
  };

  render() {
    const { project, projDashWidgets, payEstimatePilotProjectIds, projectId } = this.props;
    return (
      <React.Fragment>
        <TitleBar
          titleText={"Project Dashboard"}
          menu={adrListTitleBarMenu}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        <div className="row mx-0">
          <div className="col-md-3 px-0">
            <div className="row mx-2">
              <div className="card mb-2 bg-lightgray w-100">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center">
                    <span>
                      <b>
                        {project ? project.fullEA : fetching ? "(Loading...)" : "(N/A)"}
                      </b>
                    </span>
                    {project && (
                      <span className="ml-2">
                        <ProjectStatusBubble status={project.projectStatus} />
                      </span>
                    )}
                  </div>
                  <span>
                    {project ? project.efis : fetching ? "(Loading...)" : "(N/A)"}
                  </span>
                  <br />
                  <span>
                    {project ? project.distCoRtePm : fetching ? "(Loading...)" : "(N/A)"}
                  </span>
                  <br />
                </div>
              </div>
            </div>
            <div className="row mx-2">
              <div className="card mb-2 bg-lightgray w-100">
                <div className="card-body p-3">
                  <h6>Project Links</h6>
                  <hr className="mt-1 mb-2" />
                  <button
                    type="button"
                    name="projAdmin"
                    className="btn btn-link pl-1"
                    onClick={this.handleClick_quickLink}
                  >
                    Project Admin (Setup)
                  </button>
                  <br />
                  <button
                    type="button"
                    name="projAssignments"
                    className="btn btn-link pl-1 text-left"
                    onClick={this.handleClick_quickLink}
                  >
                    Project Assignments (miniWEAT)
                  </button>
                  <hr className="my-1" />
                  {(payEstimatePilotProjectIds.length === 0 || payEstimatePilotProjectIds.includes(projectId)) && (
                    <>
                      <button
                        type="button"
                        name="payEstimates"
                        className="btn btn-link pl-1 text-left"
                        onClick={this.handleClick_quickLink}
                      >
                        Progress Pay Estimates <PilotBadge />
                      </button>
                      <br />
                    </>
                  )}
                  <button
                    type="button"
                    name="adrList"
                    className="btn btn-link pl-1 text-left"
                    onClick={this.handleClick_quickLink}
                  >
                    Assist. RE/SR Daily Reports
                        </button>
                  <hr className="my-1" />
                  <button
                    type="button"
                    name="reDashboard"
                    className="btn btn-link pl-1 text-left"
                    onClick={this.handleClick_quickLink}
                  >
                    RE Dashboard
                                
                  </button>
                  <br />
                  <button
                    type="button"
                    name="projDocumentation"
                    className="btn btn-link pl-1 text-left"
                    onClick={this.handleClick_quickLink}
                  >
                    OE Plans and Specs
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9 px-2">
            <div className="card bg-lightgray">
              <div className="card-body p-2">
                <div className="row mb-2">
                  <div className="col-12">
                    {/* <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary align-center"
                      name="scrollLeft"
                      onClick={this.handleClick_scrollLeft}
                    >
                      &#60;
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary float-right"
                    >
                      <FontAwesomeIcon icon="cog" className="fa-fw mr-2" />
                      Edit Dashboard...
                    </button>
                  </div>
                </div>
                <div className="row mb-2">{projDashWidgets && this.renderWidgets()}</div>
                <div className="row">
                  <div className="col-4 pr-1">
                    <div className="card h-100 dash-min-height overflow-hidden">
                      <div className="card-body p-2">
                        {/* <h6 className="text-right"></h6> */}
                        <hr className="mt-1 mb-0" />
                        <div className="dash-pos-bottom px-2">
                          <hr className="my-2" />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-dark float-right mb-2"
                            disabled
                          >
                            <FontAwesomeIcon icon="info-circle" className="fa-fw mr-1" />
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 px-1">
                    <div className="card h-100 dash-min-height overflow-hidden">
                      <div className="card-body p-2">
                        {/* <h6 className="text-right"></h6> */}
                        <hr className="mt-1 mb-0" />
                        <div className="dash-pos-bottom px-2">
                          <hr className="my-2" />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-dark float-right mb-2"
                            disabled
                          >
                            <FontAwesomeIcon icon="info-circle" className="fa-fw mr-1" />
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 pl-1">
                    <div className="card h-100 dash-min-height overflow-hidden">
                      <div className="card-body p-2">
                        {/* <h6 className="text-right"></h6> */}
                        <hr className="mt-1 mb-0" />
                        <div className="dash-pos-bottom px-2">
                          <hr className="my-2" />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-dark float-right mb-2"
                            disabled
                          >
                            <FontAwesomeIcon icon="info-circle" className="fa-fw mr-1" />
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  authentication: state.authentication,
  project: state.projects.openProjectDetails[ownProps.projectId] || null,
  projDashWidgets: state.dash.project[ownProps.projectId],
  openTabs: state.mainTabs.openTabs,
  fetching: state.projects.fetching,
  payEstimatePilotProjectIds: state.appSettings.payEstimatePilotProjectIds ?? [],
});

export default connect(mapStateToProps)(ProjDash);
